import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';

export default class MapLocPointer extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene) {
    super(scene);
    this.locShadow = ABCyaPhaser.Images.addImage(0,0,'map-location-shadow', this);

    this.locIcon = ABCyaPhaser.Images.addImage(0,0,'location-icon', this).setOrigin(0.5, 1);
  }
}